document
  .querySelectorAll("[data-fostr-open-contentdrawer-id]")
  .forEach((opener) => {

    const drawerId = opener.getAttribute("data-fostr-open-contentdrawer-id");
    const contentdrawer = document.getElementById(drawerId);
    if (!contentdrawer) return;

    // overlay = fratello immediatamente dopo la section (nel tuo HTML è così)
    const overlay = contentdrawer.nextElementSibling?.classList.contains("overlay-filter")
      ? contentdrawer.nextElementSibling
      : document.querySelector(".overlay-filter");

    const filters = document.querySelectorAll(
      "#fostr-contentdrawer-filters #FacetsWrapperDesktop details"
    );

    const theopener = opener;

    const closebuttons = contentdrawer.querySelectorAll(
      ".fostr-contentdrawer__close, .fostr-contentdrawer__additional-close-button"
    );

    const curtain = contentdrawer.querySelector(".fostr-contentdrawer__curtain");
    const spacer = contentdrawer.querySelector(".fostr-contentdrawer__spacer");

    const focusable = getFocusableElements(contentdrawer) || [];
    const firstFocusable = focusable.length
      ? focusable[0]
      : (closebuttons[0] || theopener);

    function open() {
      checkSelectedOnOpen();
      contentdrawer.setAttribute("aria-expanded", "true");
      contentdrawer.classList.add("active");
      contentdrawer.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
      trapFocus(contentdrawer, firstFocusable);
    }

    function close() {
      closeFiltersAccordions();
      contentdrawer.setAttribute("aria-expanded", "false");
      contentdrawer.classList.remove("active");
      contentdrawer.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
      theopener.focus();
    }

    function checkSelectedOnOpen() {
      filters.forEach((filter) => {
        filter.querySelectorAll("input").forEach((checkbox) => {
          if (checkbox.checked) {
            filter.setAttribute("open", "");
            filter.querySelector("summary")?.setAttribute("aria-expanded", "true");
          }
        });
      });
    }

    function closeFiltersAccordions() {
      filters.forEach((filter) => {
        filter.removeAttribute("open");
        filter.querySelector("summary")?.setAttribute("aria-expanded", "false");
      });
    }

    opener.addEventListener("click", (e) => {
      e.preventDefault();
      open();
    });

    closebuttons.forEach((btn) => btn.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    }));

    if (spacer) spacer.addEventListener("click", close);
    if (curtain) curtain.addEventListener("click", close);
    if (overlay) overlay.addEventListener("click", close);
  });